

import React, { useCallback, useEffect, useState } from 'react'
import { showToast } from '../showToast';
import moment from 'moment'
import { useForm } from '../../hooks';

export const useGetExchangeRatesData=()=>{
 const {isLoading,saveForm}=useForm("")
 const [filterData,setFilterData]=useState({month:((moment().month())+1)?.toString(),year:(moment().year())?.toString()})
   
 const [data,setData]=useState([])

  const getExchangeRates = useCallback(async(callback) => {
     try{
        const response=await saveForm({...filterData,"country":window.shipmentCountry},undefined,"CCY_EXCHANGE_RATE_LIST_GET")
        if(response){
          callback && callback()
          setData(response.exchangeRateList)
        }
    }
     catch(e){

     }
  }, [filterData])

  useEffect(()=>{
    getExchangeRates()
   },[getExchangeRates])


  const updateCustomRates=async()=>{
    const response=await saveForm({"country":window.shipmentCountry},undefined,"CCY_EXCHANGE_RATE_FROM_CUSTOM")
    if(response){
      getExchangeRates(()=>{
        showToast("Exchange Rates updated successfully",undefined,'exchangeRateWarning')
      })
    }
  }

  const copySelectedRow=useCallback((params)=>{
   const clonedFromId=params.id
   const isDataAlreadyCloned=data?.find(c=>c.clonedFromId==clonedFromId)

   if(isDataAlreadyCloned)
      showToast("There is already unsaved changes",undefined,'exchangeRateWarning')
   
   else{
   setData(prevData=>{
    const index=prevData.findIndex(c=>c.id==params.id)
     const data=[...prevData]
     data.splice(index, 0, {...params,fromDate:moment().format("MM-DD-YYYY"),toDate:moment().endOf('month').format("MM-DD-YYYY"),id:Date.now(),isNewRow:true,clonedFromId});
     return data
   }) 
   }
  },[data])

  const onChange=useCallback((params)=>{
   setData(prevData=>{
     const index=prevData.findIndex(c=>c.id==params.id)
     const data=[...prevData]
     data[index]={...data[index],...params}
     return data
   })
 },[])
 const deleteRow=useCallback((id)=>{
  setData(prevData=>(prevData.filter(c=>c.id!=id)))
},[])
 const saveExchangeRate=useCallback(async(params)=>{

    const prevFromDate=data?.find(c=>c.id==params.clonedFromId)
    if(moment(params.fromDate).isSame(prevFromDate?.fromDate)){
      showToast("Please update fromDate.",undefined,'exchangeRateWarning')
    }
    else if(parseFloat(params.exchangeRate)==parseFloat(prevFromDate?.exchangeRate)){
      showToast("Please update Exchange Rate.",undefined,'exchangeRateWarning')
    }
    else{
       const response=await saveForm({...params,"country":window.shipmentCountry},undefined,"CCY_EXCHANGE_RATE_LIST_POST")
       if(response){
        const {newExchangeRate,oldExchangeRate}=response
       setData(prevData=>{
        const index=prevData.findIndex(c=>c.id==params.id)
        const clonedFromIndex=prevData.findIndex(c=>c.id==params.clonedFromId)
        const data=[...prevData]
        data[index]={...data[index],isNewRow:false,clonedFromId:null,...newExchangeRate}
        data[clonedFromIndex]={...data[clonedFromIndex],...oldExchangeRate}
        return data
       })
    }
  }
 },[data])
 

  return {isLoading,getExchangeRates,data,copySelectedRow,onChange,saveExchangeRate,deleteRow,updateCustomRates,setFilterData,filterData}
}